<i class="icon icon-tank-type{{tankType()}}" [ngClass]="inputClass()"></i>
